import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import PropTypes from 'prop-types';
import Content from './Content';

import ArrowIcon from '../../../../../images/arrow_nav.svg';
import { ContainerStyled, HeaderStyled } from './styles/DetailsAccordionStyled';

const DetailsAccordion = ({ data, isToggledInit }) => {
  const [toggled, setToggle] = useState(isToggledInit);

  const toggle = () => {
    setToggle(!toggled);
  };

  return (
    <ContainerStyled>
      <HeaderStyled onClick={toggle}>
        <p>Ver detalles Boleta</p>
        <img
          className={`arrow-acc ${toggled ? 'toggled' : ''}`}
          src={ArrowIcon}
          alt="arrow"
        />
      </HeaderStyled>

      <AnimatePresence initial={false}>
        {toggled && <Content currentData={data} />}
      </AnimatePresence>
    </ContainerStyled>
  );
};

DetailsAccordion.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  isToggledInit: PropTypes.bool,
};

DetailsAccordion.defaultProps = {
  isToggledInit: false,
};

export default DetailsAccordion;
